import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { breakpoints, container, palette, spacing, Title } from 'main/ui'
import { UnreachableCaseError } from 'main/util/ts'
import { BackgroundColor, Padding } from './types'

const backgroundColors: { [key in BackgroundColor]: string } = {
  [BackgroundColor.White]: palette.white,
  [BackgroundColor.WhiteDove]: palette.whiteDove,
}

function paddingStyles(padding: Padding) {
  switch (padding) {
    case Padding.Normal:
      return css`
        padding: ${spacing.majorScale(4)}px ${spacing.majorScale(2)}px;
      `

    default:
      throw new UnreachableCaseError(padding)
  }
}

interface IContainerProps {
  backgroundColor: BackgroundColor
  padding: Padding | null
}

export const Container = styled.div<IContainerProps>`
  ${({ padding }) => (padding ? paddingStyles(padding) : null)}

  background-color: ${({ backgroundColor }) => backgroundColors[backgroundColor]};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const ContentContainer = styled.div`
  flex-grow: 1;
  margin: 0 auto;
  max-width: ${container.maxWidth.sm}px;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    max-width: ${container.maxWidth.lg}px;
  }
`

export const StyledTitle = styled(Title)`
  margin-bottom: ${spacing.majorScale(1)}px;
`
